module.exports = __webpack_public_path__ + "img/yxx.d641f94d.gif";